import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import WelcomePage from "./pages/WelcomePage";
import Home from "./pages/Home";
import Game from "./pages/Game";
// Import admin related pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./components/AdminLayout";
import PageNotFound from "./pages/PageNotFound";


// Layout wrapper to handle admin page styling
const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if current path is an admin path
    const isAdminPage = location.pathname.startsWith("/admin");

    // Add or remove admin-layout class based on current path
    if (isAdminPage) {
      document.body.classList.add("admin-layout");
      document.documentElement.classList.add("admin-layout");
    } else {
      document.body.classList.remove("admin-layout");
      document.documentElement.classList.remove("admin-layout");
    }
  }, [location]);

  return (
    <Routes>
      {/* Welcome page as the default landing page */}
      <Route path="/" element={<WelcomePage />} />
      <Route path="/home" element={<Home />} />
      <Route path="/game" element={<Game />} />
      <Route path="/story/:storyId" element={<Game />} />
      {/* Admin routes - all handled by AdminLayout */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/*" element={<AdminLayout />} />
      {/* 404 Not Found Route - this should be the last route */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
};

export default App;
